'use client';

import Link from 'next/link';
import { cn } from '@/lib/utils';

interface EnablingClauseLinkProps {
  /** The text to display as the link */
  children: React.ReactNode;
  /** The regulation ID to link to */
  regulationId: string;
  /** Additional CSS classes */
  className?: string;
}

/**
 * Renders an enabling clause as a link to the referenced regulation.
 *
 * Enabling clauses are legal provisions that delegate authority to create
 * new regulations (e.g., "ditetapkan sebagai Peraturan Pemerintah").
 *
 * This component provides visual distinction from regular article references
 * through different styling (solid underline vs dotted).
 */
export function EnablingClauseLink({
  children,
  regulationId,
  className,
}: EnablingClauseLinkProps) {
  return (
    <Link
      href={`/regulation/indonesia/${regulationId}`}
      className={cn(
        'text-blue-600 underline decoration-solid decoration-blue-400 underline-offset-2',
        'hover:text-blue-800 hover:decoration-blue-600',
        'transition-colors',
        className
      )}
      target="_blank"
      rel="noopener noreferrer"
    >
      {children}
    </Link>
  );
}
